import 'design/assets/styles/cta/style.scss';


import { BrowserRouter } from 'react-router-dom';

import QueryClientContextProvider from 'contexts/QueryClient.context';
import { AuthenticationContextProvider } from 'contexts/Authentication.context';
import { InfrastructureContextProvider } from 'contexts/Infrastructure.context';
import { MessagesContextProvider } from 'contexts/Messages.context';
import MainRouter from 'routers/Main.router';

function App() {
  return (
    <BrowserRouter>
      <QueryClientContextProvider>
        <AuthenticationContextProvider>
          <InfrastructureContextProvider>
            <MessagesContextProvider>
              <MainRouter />
            </MessagesContextProvider>
          </InfrastructureContextProvider>
        </AuthenticationContextProvider>
      </QueryClientContextProvider>
    </BrowserRouter>
  );
}

export default App;